import { render, staticRenderFns } from "./UbicacionesCantidad.vue?vue&type=template&id=3fd14aff"
import script from "./UbicacionesCantidad.vue?vue&type=script&lang=js"
export * from "./UbicacionesCantidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports